export default {
  appendStep: 'Append step',
  insertStep: 'Insert step before',
  stepMoveUp: 'Move up',
  stepMoveDown: 'Move down',
};
